﻿
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { catchError, map, tap, finalize } from 'rxjs/operators';
import { UserSharedService } from './user-shared.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    constructor(private _sharedService: UserSharedService, private _cookies: CookieService) {
    }

    request: HttpRequest<any>;
    
    private validateAuthCookie(): boolean {
        //var userId = this._sharedService.userDetails.Email;
        //console.info("Url:" + this.request.url + " Log count start:" + this._sharedService.apiRequestCount);
        //if ((this.request.url.toLowerCase().indexOf("/login/") == -1 && (userId == undefined || userId == null || userId == ""))) {
        //    this._cookies.deleteAll();
        //   // window.location.href = this._baseSerive.APP_URL + "/vdm/#/login";
        //    return false;
        //}
        return true;
    }
    private onError(err: any): Observable<any> {
        console.log(err);
        if (err instanceof HttpResponse) {
            console.log(err.status);
            console.log(err.body);
        }
        console.info("Url:" + (this.request ? this.request.url : 'url undefined') + " Response error count end:" + this._sharedService.apiRequestCount);
        if ((err.status === 401 || err.status === 403) && (window.location.href.match(/\?/g) || []).length < 2) {
            console.log('The authentication session expires or the user is not authorised. Force refresh of the current page.');
           // window.location.href = window.location.href + '?' + new Date().getMilliseconds();
        }

        return of(err);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.request = req;

        if (!this.validateAuthCookie()) {
           // return throwError("");
        }

        this._sharedService.apiRequestCount++;

        return next.handle(req).pipe(

            map(resp => {
             
                return resp;
            }),
            catchError(this.onError),
            finalize(() => {
                this._sharedService.apiRequestCount--;
                console.info("Url:" + (req ? req.url : 'url undefined') + " response count End:" + this._sharedService.apiRequestCount);
            })
        );



    }
}